import React from 'react';
import cn from 'classnames';

import { ANIMATION_DURATION_MS } from '../headers/tabs-header/config';

import type { TProgress } from './models';
import styles from './styles.css';

export const Progress = ({ autofillTime = 7000, theme = 'light', width }: TProgress) => {
    return (
        <div className={styles.progressContainer}>
            <div
                className={cn(styles.progressElement, styles[theme])}
                style={{
                    animationDuration: `${autofillTime - ANIMATION_DURATION_MS}ms`,
                    animationDelay: `${ANIMATION_DURATION_MS}ms`,
                    width,
                }}
            />
        </div>
    );
};
